import { EAuthenticateError, EAuthenticateStatus, ETwoFactorStatus } from '../../types/authentication';
import { isEmail } from '../../utils/validation';
export function hasCodeErrorSelector(state) {
  var _state$authentication = state.authentication.authenticate,
      status = _state$authentication.status,
      errorType = _state$authentication.errorType;
  return status === EAuthenticateStatus.Failed && errorType !== EAuthenticateError.TwoFactorRequired;
}
export function codeErrorSelector(state) {
  if (!hasCodeErrorSelector(state)) {
    return undefined;
  }

  return state.authentication.authenticate.error;
}
export function isSubmittingSelector(state) {
  var _state$authentication2 = state.authentication,
      authStatus = _state$authentication2.authenticate.status,
      twoFactorStatus = _state$authentication2.twoFactor.status;
  return authStatus === EAuthenticateStatus.Loading || twoFactorStatus === ETwoFactorStatus.Loading;
}
export function helpQuerySelector(state) {
  var login = state.login;
  return [isEmail(login) ? "email=".concat(encodeURIComponent(login)) : null, 'twoFactor=true'].filter(Boolean).join('&');
}